var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.24 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#040006;}.cls-3{fill:#83a060;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-icon1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_38_copia_2",
    "data-name": "38 copia 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.3,
    cy: 114.11,
    r: 105.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M136.78,117.42l-.05-.06,12.81-12.81,14.74-2.23a4.7,4.7,0,0,0,2.65-1.33l10.12-10.13a4.79,4.79,0,0,0,1.23-2.15l3.83-14.59a4.75,4.75,0,0,0-1.23-4.55l-4.15-4.17a4.74,4.74,0,0,0-3.35-1.4h0A4.75,4.75,0,0,0,170,65.39l-11.4,11.38L156.81,75l11.38-11.39a4.76,4.76,0,0,0,0-6.7l-4-4a4.74,4.74,0,0,0-3.35-1.39,4.45,4.45,0,0,0-1.2.16l-14.59,3.83a4.71,4.71,0,0,0-2.14,1.23L132.78,66.86a4.74,4.74,0,0,0-1.33,2.64L129.26,84l-13,13L103.54,84.18l-2.22-14.75A4.72,4.72,0,0,0,100,66.79L89.85,56.67a4.71,4.71,0,0,0-2.14-1.23l-14.6-3.83a4.93,4.93,0,0,0-1.2-.15,4.74,4.74,0,0,0-3.34,1.37L64.39,57a4.74,4.74,0,0,0,0,6.7L75.77,75.1,74,76.91,62.56,65.53a4.76,4.76,0,0,0-6.7,0l-4,4a4.73,4.73,0,0,0-1.24,4.55l3.84,14.58a4.7,4.7,0,0,0,1.23,2.15l10.13,10.14a4.72,4.72,0,0,0,2.65,1.34L83,104.45l12.91,12.91-41.19,41.2A14.44,14.44,0,1,0,75.1,179l41.21-41.2L157.56,179A14.44,14.44,0,1,0,178,158.61ZM85.21,100l-16-2.41L59.07,87.44,55.24,72.86l4-4L74,83.61l8.51-8.51L67.73,60.35l4.18-4.16L86.5,60,96.64,70.14l2.41,16-.12.12,14,14L99.23,114ZM71.76,175.64A9.71,9.71,0,0,1,58,161.91l44.15-44.16a4.59,4.59,0,0,0,.41-.36l13.73-13.73a5,5,0,0,0,.37-.42l17-17,2.41-16,10.15-10.14,14.58-3.83,4,4L150.11,75l8.51,8.51,14.75-14.73,4.15,4.17-3.82,14.6L163.58,97.64l-16,2.42-.11-.12-24.28,24.28L116.28,131a4.24,4.24,0,0,0-.58.69Zm102.88,0a9.69,9.69,0,0,1-13.73,0l-41.25-41.24,6.85-6.86,6.92-6.81L174.64,162A9.7,9.7,0,0,1,174.64,175.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M169.38,162.61a5.54,5.54,0,1,1-7.83,0A5.53,5.53,0,0,1,169.38,162.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M71.11,170.39a5.54,5.54,0,1,1,0-7.83A5.55,5.55,0,0,1,71.11,170.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.62,17.85a96.77,96.77,0,0,1,68.43,165.2A96.77,96.77,0,1,1,46.2,46.2a96.1,96.1,0,0,1,68.42-28.35m0-17.85A114.62,114.62,0,1,0,229.24,114.62,114.62,114.62,0,0,0,114.62,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "114.78 283.46 166.93 216.38 62.32 216.38 114.78 283.46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIcon1);
export default __webpack_public_path__ + "static/media/ic-icon1.45785016abfd8933627791a7bc5cc946.svg";
export { ForwardRef as ReactComponent };